<template>
    <CompassEmptyState
        illustrationPath="/ressources/logged/img/illustrations/empty-automation.svg"
        :title="translations.title"
        :caption="translations.caption"
    >
        <div class="automation-listing-empty-state-no-automation__actions">
            <CompassButton
                :label="translations.actions.explore_templates"
                type="secondary"
                @click="redirectToAutomationTemplates"
            />
            <CompassButton
                :label="translations.actions.create_automation"
                @click="handleCreateAutomation"
            />
        </div>
    </CompassEmptyState>
</template>

<script>
import { createAutomation } from 'api/automation/automationService';

export default {
    data() {
        return {
            translations: {
                title: this.$t.__('automation.AutomationListingEmptyStateNoAutomation.title'),
                caption: this.$t.__('automation.AutomationListingEmptyStateNoAutomation.caption'),
                actions: {
                    explore_templates: this.$t.__(
                        'automation.AutomationListingEmptyStateNoAutomation.explore_templates',
                    ),
                    create_automation: this.$t.__(
                        'automation.AutomationListingEmptyStateNoAutomation.create_automation',
                    ),
                },
            },
        };
    },
    methods: {
        redirectToAutomationTemplates() {
            this.$router.push({ name: 'automations.templates' });
        },
        handleCreateAutomation() {
            this.isLoadingCreation = true;
            createAutomation()
                .then((response) => {
                    if (response) {
                        this.$router.push({
                            name: 'automations.flow.builder',
                            params: { id: response.data.id },
                        });
                    }
                })
                .catch((error) => {
                    this.errorsHandler.logException(error);
                    this.$pushToast({
                        type: 'error',
                        close: true,
                        text: this.$t.__('automation.AutomationLayout.error.create_automation'),
                    });
                })
                .finally(() => {
                    this.isLoadingCreation = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-listing-empty-state-no-automation {
    &__actions {
        display: flex;
        gap: var(--spacing-3);
    }
}
</style>
